export const SITE_URL = `${window.location.protocol}//${window.location.host}`;
